function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12 4a8 8 0 110 16 8 8 0 010-16zm0 1.33a6.67 6.67 0 100 13.34 6.67 6.67 0 000-13.34zm-1 8.06l3.83-3.84a.67.67 0 011.02.85l-.08.1-4.3 4.3a.67.67 0 01-.85.08l-.1-.08-2.32-2.33a.67.67 0 01.85-1.02l.09.08L11 13.39z",
  fill: "#22AD5C"
})));